import React, { useState, useRef, useEffect } from 'react';
import './RigTabs.css';

const RigTabs = ({ 
    openTabs, 
    activeTabId, 
    onTabChange, 
    onTabClose, 
    onAddTab,
    theme 
}) => {
    const tabsContainerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    // Verificar si necesitamos mostrar flechas de scroll
    useEffect(() => {
        const checkScroll = () => {
            const container = tabsContainerRef.current;
            if (!container) return;

            const { scrollLeft, scrollWidth, clientWidth } = container;
            
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 5);
        };

        const container = tabsContainerRef.current;
        if (container) {
            checkScroll();
            container.addEventListener('scroll', checkScroll);
            window.addEventListener('resize', checkScroll);

            return () => {
                container.removeEventListener('scroll', checkScroll);
                window.removeEventListener('resize', checkScroll);
            };
        }
    }, [openTabs]);

    const handleTabClick = (rigId) => {
        if (rigId !== activeTabId) {
            onTabChange(rigId);
        }
    };

    const handleCloseTab = (e, rigId) => {
        e.stopPropagation();
        onTabClose(rigId);
    };

    const scrollTabs = (direction) => {
        const container = tabsContainerRef.current;
        if (!container) return;
        
        const scrollAmount = 200;
        container.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth'
        });
    };

    if (!openTabs || openTabs.length === 0) {
        return null;
    }

    return (
        <div className="rig-tabs-container" style={{
            backgroundColor: theme.bgColor,
            borderBottom: `2px solid ${theme.gridColor}`
        }}>
            {showLeftArrow && (
                <button 
                    className="tab-scroll-arrow left"
                    onClick={() => scrollTabs('left')}
                    style={{
                        backgroundColor: theme.chartBg,
                        color: theme.fontColor
                    }}
                >
                    <i className="fa-solid fa-chevron-left"></i>
                </button>
            )}
            
            <div 
                className="rig-tabs-scroll" 
                ref={tabsContainerRef}
            >
                {openTabs.map(tab => {
                    const isActive = parseInt(activeTabId) === parseInt(tab.rigId);
                    return (
                        <div
                            key={tab.rigId}
                            className={`rig-tab ${isActive ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.rigId)}
                            style={{
                                backgroundColor: isActive 
                                    ? theme.colorFont || '#0d6efd'
                                    : theme.chartBg,
                                color: isActive 
                                    ? theme.bgColor 
                                    : theme.fontColor,
                                borderColor: theme.gridColor
                            }}
                        >
                        {/* Indicador de estado */}
                        <div className="tab-status-indicator">
                            {tab.isLoading ? (
                                <i className="fa-solid fa-spinner fa-spin" 
                                   style={{ color: '#ffc107' }}></i>
                            ) : (
                                <i className={`fa-solid fa-circle`}
                                   style={{ 
                                       color: tab.isOnline ? '#28a745' : '#dc3545',
                                       fontSize: '10px'
                                   }}></i>
                            )}
                        </div>
                        
                        {/* Información del rig */}
                        <div className="tab-content">
                            <div className="tab-rig-name" title={tab.rigName}>
                                {tab.rigName}
                            </div>
                            <div className="tab-well-name" title={tab.wellName}>
                                {tab.wellName}
                            </div>
                        </div>
                        
                        {/* Indicador de caché */}
                        {tab.hasCache && !tab.isLoading && (
                            <i className="fa-solid fa-bolt tab-cache-icon" 
                               style={{ color: '#ffc107' }}
                               title="Datos en caché - Carga instantánea"></i>
                        )}
                        
                        {/* Botón cerrar (solo si hay más de 1 tab) */}
                        {openTabs.length > 1 && (
                            <button
                                className="tab-close-btn"
                                onClick={(e) => handleCloseTab(e, tab.rigId)}
                                title="Cerrar tab"
                                style={{
                                    color: isActive 
                                        ? theme.bgColor 
                                        : theme.fontColor
                                }}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>
                    );
                })}
                
                {/* Botón agregar tab */}
                {openTabs.length < 6 && (
                    <button 
                        className="rig-tab-add"
                        onClick={onAddTab}
                        style={{
                            backgroundColor: theme.chartBg,
                            color: theme.fontColor,
                            borderColor: theme.gridColor
                        }}
                        title="Abrir nuevo rig"
                    >
                        <i className="fa-solid fa-plus"></i>
                    </button>
                )}
            </div>
            
            {showRightArrow && (
                <button 
                    className="tab-scroll-arrow right"
                    onClick={() => scrollTabs('right')}
                    style={{
                        backgroundColor: theme.chartBg,
                        color: theme.fontColor
                    }}
                >
                    <i className="fa-solid fa-chevron-right"></i>
                </button>
            )}
        </div>
    );
};

export default RigTabs;
